import { IHTMLElementWithControl } from "../Controls/ControlInterfaces";
import { Registrator } from "../Controls/Registrator";

export class ControlQueries {
    public static getDirectChildControlElements(source: Element): HTMLElement[] {
        return Array.from(source.children).filter((n, _i, _a) => n.attributes && (n.attributes.getNamedItem("data-tsccontrol")) ? true : false) as HTMLElement[]; //smazat data-role az nebude potreba
    }

    public static moveControlElements(source: Element, target: Node): void {
        const childs = ControlQueries.getDirectChildControlElements(source);
        for (let i = 0; i < childs.length; i++) {
            const child = childs[i];
            source.removeChild(child);
            target.appendChild(child);
        }
    }

    public static moveControlsToNewControlAndInitialize(source: HTMLElement, _newControlName: string): IHTMLElementWithControl {
        const movedChilds = document.createDocumentFragment();
        ControlQueries.moveControlElements(source, movedChilds);

        const internalPanelElement = document.createElement("div");
        internalPanelElement.setAttribute("data-tsccontrol", "FormInternalPanel");
        internalPanelElement.appendChild(movedChilds);

        Registrator.initializeControls(internalPanelElement);

        return internalPanelElement as HTMLElement as IHTMLElementWithControl;
    }
}
